// extracted by mini-css-extract-plugin
export default {"root":"ProductSceneTab_root__YMz53","carousel":"ProductSceneTab_carousel__aHM-y"};